export default {
  /* 前台用户 */
  appLogin: '/user/appLogin/V2', // 登录
  getUserGradeInfo: '/user/getUserGradeInfo', // 登录
  getUserGradeDiscount: '/order/getUserGradeDiscount', // 登录
  wxOauth: '/user/wxOauth2', // 登录
  isParcelType: '/system/isParcelType', // 包裹预报是否配置了货物类型
  isParcelUnpack: '/system/isParcelUnpack', // 是否可拆包
  bindingMobile: '/user/bindingMobile', // 登录
  sendEmailCode: '/user/sendEmailCode', // 发送邮箱验证码
  appRegister: '/user/appRegister/v4',  // app注册3
  getUserInfo: '/user/getUserInfo', // 获取用户基础信息
  updateUserCountry: '/user/updateUserCountry',
  getMobileCode: '/mobile/getMobileCode',
  sendMobileCode: '/mobile/sendMobileCode',
  userupdate: '/user/update', // 修改用户基础信息
  updatePassword: '/user/updatePassword', // 修改密码
  loginOut: '/user/loginOut', // 退出登入
  sendPasswordMail: '/user/sendPasswordMail', // 忘记密码发送邮件
  getUserCredituer: '/user/getUserCredit', // 获取用户积分信息
  bindEmail: '/user/bindEmail/v3', // 绑定邮箱
  updateProductPrices: '/parcel/updateProductPrices',
  /* 轮播图 */
  banner: '/banner/list', // 获取轮播图
  /* 消息信息 */
  getMessageCount: '/message/getMessageCount', // 获取未读消息数量
  getMessageList: '/message/getMessageList', // 获取消息列表
  /* 省市区模块 */
  country: '/district/list', // 查看下级地址列表
  districtsearch: '/district/search', // 查找地址信息
  /* 服务价格模块 */
  getRecommendService: '/servicePrice/getRecommendService',  // 推荐线路
  countPrice: '/servicePrice/countPrice/v2', // 粗略计算价格
  servicePrice: '/servicePrice/listByCountry', // 根据国家获取服务列表
  realPrice: '/servicePrice/realPrice/v2', // 真实运费价格
  servicePricelist: '/servicePrice/list', // 获取服务列表
  getCreditPrice: '/servicePrice/getCreditPrice', // 真实积分价格
  /* 配置中心 */
  getStoreInfo: '/system/getStoreInfo', // H5 登入注册页配置
  appContext: '/system/appContext', // app内容
  appReback: '/system/appReback', // app退货相关
  /* 文章模块 */
  getMessageById: '/article/getMessageById', // 根据文章id查找
  getMessageByName: '/article/getMessageByName', // 根据文章name查找
  /* 优惠券模块 */
  couponInfo: '/coupons/couponInfo', // 获取新人优惠券信息
  newcomer: '/coupons/newcomer', // 领取新人优惠券
  couponsexchange: '/coupons/exchange', // 兑换优惠券
  couponslist: '/coupons/list', // 我的优惠券列表
  couponsallCount: '/coupons/allCount', // 我的优惠券列表(数量)
  /* 常见问题模块 */
  normalQuestion: '/normalQuestion/getList/v2', // 获取常见问题列表
  normalQuestiondetail: '/normalQuestion/detail', // 获取常见问题详情
  /* 推广管理模块 */
  promotion: '/promotion/pv', // pv
  /* 仓库配置模块 */
  buildAddress: '/wareHouse/buildAddressV2', // 生成仓库地址信息
  getWareHouse: '/wareHouse/getWareHouse',
  /* 地址控模块 */
  addresslist: '/address/list', // 获取普通地址列表
  addressupdate: '/address/update', // 更新或者添加地址
  setDefault: '/address/setDefault', // 设置默认地址
  addressdeleted: '/address/deleted/v2', // 删除地址
  addressthe: '/address/the', // 查看这个地址详情
  mallList: '/address/mallList', // 获取我的超商地址列表
  osuploads: '/oss/upload', // 上传图片
  feedBack: '/feedBack/add', // 反馈
  getMaxParcelNumByCountry: '/country/getMaxParcelNumByCountry',//最大
  /* 超商配置 */
  hasMallInfo: '/mall/hasMallInfo', // 是否可以超商配送
  getMallInfo: '/mall/getMallInfo', // 获取超商地图信息
  /* 用户积分模块 */
  getUserCredit: '/credit/getUserCredit', // 查询用户积分
  getUserCreditDetail: '/credit/getUserCreditDetail', // 查询用户积分详情
  /* 活动模块 */
  getActive: '/active/getActive',
  /* 国家相关配置 */
  isShowShop: '/country/isShowShop', // 根据国家展示商城配置
  getPayWarnInfo: '/country/getPayWarnInfo', // 根据国家查询支付警告提示语
  /* 支付模块 */
  hongKongpayment: '/pay/hongKong/payment',
  ljPay: '/pay/hongKong/ljPay',
  aliPay: '/pay/aliPay',
  payshopsubmit: '/pay/submit',
  successPay: '/pay/successPay',
  paywayshop: '/pay/way',
  payway: '/pay/v2/way',
  paysubmit: '/pay/v2/submit',
  localPay: '/pay/v2/localPay',
  taoBaoPay: '/pay/v2/taoBaoPay',
  /* 包裹服务 */
  queryLogisticsNameInfo: '/parcel/queryLogisticsNameInfo',
  deleteProduct: '/parcel/deleteProduct',
  parceladd: '/parcel/add',
  parcellist: '/parcel/list',
  parcelsimpleStatus: '/parcel/simpleStatus',
  arcel: '/parcel/the',
  parceldelete: '/parcel/delete/v2',
  parcelcomplete: '/parcel/complete',
  parcelsearch: '/parcel/search',
  logisticsInfo: '/parcel/logisticsInfo',
  parcelindexList: '/parcel/indexList',
  parcelRejection: '/parcel/parcelRejection',
  parcelCancelRejection: '/parcel/parcelCancelRejection',
  deleteException: '/parcel/deleteException',
  /* 订单模块 */
  orderlist: '/order/list',
  detailmessage: '/message/detail',
  orderpayList: '/order/payList',
  simpleStatus: '/order/simpleStatus',
  orderready: '/order/ready',
  isReinforce: '/order/isReinforce',
  ordersubmit: '/order/submit',
  ordercancel: '/order/cancel',
  ordersearch: '/order/search',
  orderdetail: '/order/detail',
  getAddedCharge: '/order/getAddedCharge',
  getTriggerParcelTotalSurchargesMoney: '/order/getTriggerParcelTotalSurchargesMoney',
  getlogisticsInfo: '/order/getLogisticsInfo',
  getAdded: '/order/getAdded',
  orderMergeNotice: '/order/orderMergeNotice',
  parcelBack: '/order/parcelBack/v2',
  orderindexList: '/order/indexList',
  cancelorder: '/order/cancel/v2',
  cancelAfoot: '/order/cancelAfoot',
  cancelAfootOverNoPay: '/order/cancelAfootOverNoPay',
  getUserCouponValidByOrderId: '/coupons/getUserCouponValidByOrderId',
  submitRearOrder: '/order/submitRearOrder',
  delOrder: '/order/delOrder/v2',
  checkSubmit: '/order/checkSubmit',
  isRemark: '/order/isRemark',
  /* 任务模块 */
  getOtherTaskList: '/shopTask/getOtherTaskList', // 查询其他任务
  getSignTaskList: '/shopTask/getSignTaskList', // 查询签到任务
  doSignTask: '/shopTask/doSignTask', // 执行其他任务
  /* 用户账号模块 */
  getUserAccount: '/account/getUserAccount', // 获取账户余额
  accountrecord: '/account/record', // 账户余额记录/C端
  /* 充值模块 */
  shopDepositlist: '/shopDeposit/list', // 充值列表
  /* 积分商品模块 */
  getPointsProduct: '/pointsProduct/getPointsProduct', // 查询积分商品
  changePointsProduct: '/pointsProduct/changePointsProduct', // 兑换积分商品(优惠券)
  getExchangeHistory: '/pointsProduct/getExchangeHistory', // 查询积分兑换记录
  getPointsProductDetail: '/pointsProduct/getPointsProductDetail', // 查询积分商品详情
  /* 公告模块 */
  getCountryNotice: '/notice/getCountryNotice/v2', // 获取国家公告列表
  getEjectNotice: '/notice/getEjectNotice/v2', // 获取弹出公告
  getHomeNotice: '/notice/getHomeNotice/v2', // 获取首页公告
  noticeDetail: '/notice/noticeDetail', // 公告详情
  /* 订单申报人模块 */
  deleteDeclare: '/order/declare/delete', // 删除历史申报人
  declareHistoryList: '/order/declare/historyList', // 历史申报人
  saveDeclareOrder: '/order/declare/save', // 保存申报人
  getLineService: '/user/getLineService', // linkfu
  getShopServiceByWarehouseId: '/servicePrice/getShopServiceByWarehouseId', // 根据店铺仓库获取对应线路
  getShopWarehouseByCountryId: '/servicePrice/getShopWarehouseByCountryId', // 根据国家/地区获取店铺仓库
  getUserFeed: '/feedBack/getUserFeed', // 根据国家/地区获取店铺仓库
  checkEntrust: '/order/declare/checkEntrust', // 根据国家/地区获取店铺仓库
  getLineNotifyOauthUrl: '/line/getLineNotifyOauthUrl', // 获取line通知授权入口
  isLineNotify: '/line/isLineNotify', // 获取line通知授权入口
}
